import tomes from '../../data/tomes'
import Tome from '../../models/Tome'

// initial state
const state = () => ({

})

// getters
const getters = {
    stats: () => {
        const tome = Tome.all()
        const stats = {}
        stats.total = tome.map(tome => tome.total).reduce((prev, next) => prev + next)
        stats.completed = tome.map(tome => tome.completed).reduce((prev, next) => prev + next)
        stats.progress = Math.round(stats.completed / stats.total * 100)
        return stats
    },
    filtered: (state, getters, rootState) => {
        switch (rootState.configurations.filter) {
            case "completed":
                return Tome.query().where((tome) => tome.completed == tome.total).get()
            case "uncompleted":
                return Tome.query().where((tome) => tome.completed < tome.total).get()
            default:
                return Tome.all();
        }
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', tomes)
    },
    increment({ commit }, tome) {
        commit('increment', { tome })
    },
    decrement({ commit }, tome) {
        commit('decrement', { tome })
    }
}

// mutations
const mutations = {
    load(state, tomes) {
        // Restore completed tome
        tomes.forEach(tome => {
            const persistedTome = Tome.query().where((persistedTome) => { return persistedTome.area_id == tome.area_id }).first()
            if (persistedTome) {
                tome.completed = persistedTome.completed
            }
        });
        Tome.create({
            data: tomes
        })
    },
    increment(state, { tome }) {
        if (tome.completed < tome.total) {
            Tome.update({
                where: tome.area_id,
                data: {
                    completed: tome.completed + 1
                }
            })
        }
    },
    decrement(state, { tome }) {
        if (tome.completed > 0) {
            Tome.update({
                where: tome.area_id,
                data: {
                    completed: tome.completed - 1
                }
            })
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}